import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { summarySelector } from '../MoneyGuidProSelectors';
import { SummaryChart } from './SummaryChart/SummaryChart';
import { summaryReducerPrefix } from '../MoneyGuideProConstants';

import {
  SummaryCharts,
  Cell,
  TableContent,
  TableGroup,
  TableHeader,
  TableRow,
  TableWrapper,
  ColumnCell,
} from './SummaryStyles';
import { Tab } from '../Tab/Tab';
import { useIsEmbeddedMobile } from '../../_hooks/useIsEmbeddedMobile';
import { SummaryMobile } from './SummaryMobile/SummaryMobile';

export const Summary: React.FC<{ id: number; clientId: string }> = ({ id, clientId }) => {
  const data = useSelector(summarySelector);
  const isEmbeddedMobile = useIsEmbeddedMobile();

  return (
    <>
      <Tab
        tabTitle="Plan Summary"
        mgpItemId={id}
        clientId={clientId}
        asOfDate={data ? data.asOfDate : null}
        reducerPrefix={summaryReducerPrefix}
        isEmpty={data === null}
        isPristine={data === undefined}
      >
        {data ? (
          <>
            {isEmbeddedMobile ? (
              <SummaryMobile />
            ) : (
              <>
                <SummaryCharts>
                  <SummaryChart title="Current Scenario" data={data.chartsData[0]} />
                  <SummaryChart title="Recommended Scenario" data={data.chartsData[1]} />
                </SummaryCharts>
                <TableWrapper>
                  <TableRow>
                    <ColumnCell />
                    <ColumnCell>{data.header.description}</ColumnCell>
                    <ColumnCell>{data.header.current}</ColumnCell>
                    <ColumnCell>{data.header.recommended}</ColumnCell>
                    <ColumnCell>{data.header.changes}</ColumnCell>
                  </TableRow>
                  <TableContent>
                    {data.summaryCategories.map(category => (
                      <div key={category.description}>
                        <TableGroup>
                          <TableHeader>{category.description}</TableHeader>
                          <ColumnCell>
                            <strong>{category.current}</strong>
                          </ColumnCell>
                          <ColumnCell>
                            <strong>{category.recommended}</strong>
                          </ColumnCell>
                          <ColumnCell>
                            <strong>{category.changes}</strong>
                          </ColumnCell>
                        </TableGroup>
                        {category.topics.map(topic => (
                          <div key={topic.description}>
                            <TableRow
                              style={{ background: '#f6f6f6', borderBottom: '1px solid #ccc' }}
                            >
                              <TableHeader>{topic.description}</TableHeader>
                              <ColumnCell>
                                <strong>{topic.current}</strong>
                              </ColumnCell>
                              <ColumnCell>
                                <strong>{topic.recommended}</strong>
                              </ColumnCell>
                              <ColumnCell>
                                <strong>{topic.changes}</strong>
                              </ColumnCell>
                            </TableRow>
                            {topic.items.map(
                              ({ current, description, recommended, changes, details }, index) => (
                                // eslint-disable-next-line react/no-array-index-key
                                <React.Fragment key={`${index}-${description}-${current}`}>
                                  <TableRow style={{ borderBottom: '1px solid #ccc' }}>
                                    <Cell>{description}</Cell>
                                    <ColumnCell>{current}</ColumnCell>
                                    <ColumnCell>{recommended}</ColumnCell>
                                    <ColumnCell>{changes}</ColumnCell>
                                  </TableRow>
                                  {details?.map(detail => (
                                    <TableRow
                                      key={detail.description}
                                      style={{
                                        borderBottom: '1px solid #ccc',
                                        paddingLeft: '16px',
                                      }}
                                    >
                                      <Cell>{detail.description}</Cell>
                                      <ColumnCell>{detail.current}</ColumnCell>
                                      <ColumnCell>{detail.recommended}</ColumnCell>
                                      <ColumnCell>{detail.changes}</ColumnCell>
                                    </TableRow>
                                  ))}
                                </React.Fragment>
                              ),
                            )}
                          </div>
                        ))}
                      </div>
                    ))}
                  </TableContent>
                </TableWrapper>
              </>
            )}
          </>
        ) : null}
      </Tab>
    </>
  );
};
